import { useMemo } from 'react';
import { FilterType } from '../types';

export const useFilterSearch = (
  searchQuery: string,
  modalType: FilterType,
  categories: string[],
  domains: string[],
  subDomains: string[],
  documents: string[]
) => {
  return useMemo(() => {
    const query = searchQuery.toLowerCase();
    const filterOptions = (options: string[]) => options.filter((opt) => opt.toLowerCase().includes(query));

    switch (modalType) {
      case 'category':
        return filterOptions(categories);
      case 'domain':
        return filterOptions(domains);
      case 'subDomain':
        return filterOptions(subDomains);
      case 'document':
        return filterOptions(documents);
      default:
        return [];
    }
  }, [searchQuery, modalType, categories, domains, subDomains, documents]);
};
